import * as actionTypes from './actionTypes';

import {
  subscribeUserBySSID,
} from '@/finsight/application/actions/subscriptions/actions';

import { ITEMS_PER_PAGE_WITH_BUFFER } from './constants';

import DealRepository from '@/finsight/infrastructure/repository/DealRepository';

import createAction from '@/Framework/State/Redux/createAction';
import createAsyncRequest from '@/Framework/State/Redux/createAsyncRequest';
import { preparePayload } from '@/finsight/application/actions/deals/helpers';

export const resetDeals = () => createAction(actionTypes.RESET_DEALS);

export const setDealsPage = (page: number) => createAction(actionTypes.SET_DEALS_PAGE, page);

/**
 * Get deals by filters from the store
 * @return {Function}
 */
export const getDealsTile = () => (dispatch, getState) => {
  const { pageFilters } = getState();
  const dealRepository: DealRepository = getState().container.get(DealRepository);

  dispatch(createAsyncRequest(
    {
      payload: {
        ...preparePayload(pageFilters, 1),
        perPage: ITEMS_PER_PAGE_WITH_BUFFER,
      },
      method: dealRepository.getDealsWithSubscriptionStatus,
      types: [
        actionTypes.GET_DEALS_TILE,
        actionTypes.GET_DEALS_TILE_SUCCESS,
        actionTypes.GET_DEALS_TILE_FAILURE,
      ],
      callbacks: {
        responseHandler: (response) => ({
          ...response.deals,
          collection: response.deals.collection.slice(0, 10),
          subscriptionStatus: response.subscriptionStatus,
        }),
        onSuccess: ({ response, dispatch }) => {
          dispatch(createAction(
            actionTypes.GET_BUFFER_DEALS_SUCCESS, { collection: response.deals.collection.slice(10) },
          ));
        },
      },
    },
  ));
};

export const subscribeToDealDidgestBySSID = (payload, onSuccess) => subscribeUserBySSID(payload, [
  actionTypes.CREATE_DEALS_SUBSCRIPTION,
  actionTypes.CREATE_DEALS_SUBSCRIPTION_SUCCESS,
  actionTypes.CREATE_DEALS_SUBSCRIPTION_FAILURE,
], onSuccess);
